module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_8004.667823c5.png";